import React from 'react'
import cn from 'classnames'

import styles from './financeOnboarding.module.scss'

// Ilustrasi welcome: lembar tagihan, gelembung WhatsApp, kartu Laba Rugi, koin, centang.
const WelcomeIllustration = () => (
  <svg viewBox="0 0 520 440" aria-hidden="true">
    <defs>
      <linearGradient id="foGBL" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#8fb0fb" />
        <stop offset="1" stopColor="#6c98f8" />
      </linearGradient>
    </defs>
    <ellipse cx="260" cy="400" rx="190" ry="16" fill="#1f2d5c" opacity=".07" />
    <g className={styles.float}>
      <rect
        x="120"
        y="70"
        width="230"
        height="290"
        rx="18"
        fill="#fff"
        stroke="#c5d5fb"
        strokeWidth="2"
      />
      <rect x="120" y="70" width="230" height="56" rx="18" fill="url(#foGBL)" />
      <rect x="120" y="100" width="230" height="26" fill="url(#foGBL)" />
      <text x="148" y="106" fontFamily="inherit" fontSize="16" fontWeight="800" fill="#fff">
        INV/00001
      </text>
      <rect x="148" y="150" width="120" height="10" rx="5" fill="#dbe6ff" />
      <rect x="148" y="172" width="170" height="10" rx="5" fill="#eef3fe" />
      <rect x="148" y="194" width="140" height="10" rx="5" fill="#eef3fe" />
      <line x1="148" y1="222" x2="322" y2="222" stroke="#e4e9f0" strokeWidth="2" />
      <rect x="148" y="238" width="90" height="10" rx="5" fill="#dbe6ff" />
      <rect x="262" y="236" width="60" height="14" rx="7" fill="#1f2d5c" />
      <rect x="148" y="262" width="60" height="10" rx="5" fill="#eef3fe" />
      <rect x="292" y="260" width="30" height="14" rx="7" fill="#dbe6ff" />
      <rect x="148" y="300" width="174" height="38" rx="10" fill="#4677f3" />
      <text
        x="235"
        y="325"
        textAnchor="middle"
        fontFamily="inherit"
        fontSize="15"
        fontWeight="800"
        fill="#fff"
      >
        Simpan
      </text>
    </g>
    <g className={styles.bubble}>
      <path
        d="M330 150 h120 a16 16 0 0 1 16 16 v52 a16 16 0 0 1-16 16 h-92 l-22 18 v-18 h-6 a16 16 0 0 1-16-16 v-52 a16 16 0 0 1 16-16Z"
        fill="#25d366"
      />
      <rect x="346" y="168" width="96" height="9" rx="4.5" fill="#fff" opacity=".95" />
      <rect x="346" y="186" width="70" height="9" rx="4.5" fill="#fff" opacity=".75" />
      <rect x="346" y="204" width="84" height="9" rx="4.5" fill="#fff" opacity=".75" />
      <path
        d="M424 216 l4 4 8-9"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M430 216 l4 4 8-9"
        fill="none"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity=".7"
      />
    </g>
    <g className={cn(styles.float, styles.floatD2)}>
      <rect
        x="40"
        y="250"
        width="150"
        height="120"
        rx="14"
        fill="#fff"
        stroke="#c5d5fb"
        strokeWidth="2"
      />
      <text
        x="58"
        y="276"
        fontFamily="inherit"
        fontSize="11"
        fontWeight="800"
        fill="#8a91a5"
        letterSpacing="1"
      >
        LABA RUGI
      </text>
      <path
        className={styles.draw}
        d="M58 344 L84 332 L110 322 L134 300 L170 282"
        fill="none"
        stroke="#4677f3"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="170" cy="282" r="12" fill="#4677f3" opacity=".2" className={styles.ringAnim} />
      <circle cx="170" cy="282" r="6" fill="#4677f3" stroke="#fff" strokeWidth="2" />
    </g>
    <g className={styles.coin}>
      <circle cx="410" cy="300" r="22" fill="#f8b95c" />
      <circle cx="410" cy="300" r="14" fill="none" stroke="#fff" strokeWidth="3" opacity=".9" />
      <text
        x="410"
        y="305"
        textAnchor="middle"
        fontFamily="inherit"
        fontSize="14"
        fontWeight="800"
        fill="#fff"
      >
        Rp
      </text>
    </g>
    <g className={cn(styles.coin, styles.coinC2)}>
      <circle cx="452" cy="340" r="16" fill="#f8b95c" />
      <circle cx="452" cy="340" r="9" fill="none" stroke="#fff" strokeWidth="2.5" opacity=".9" />
    </g>
    <g className={cn(styles.coin, styles.coinC3)}>
      <circle cx="70" cy="120" r="14" fill="#f8b95c" />
      <circle cx="70" cy="120" r="8" fill="none" stroke="#fff" strokeWidth="2.5" opacity=".9" />
    </g>
    <g className={styles.pop}>
      <circle cx="352" cy="82" r="26" fill="#46be8a" />
      <path
        d="M340 82 l8 8 16-18"
        fill="none"
        stroke="#fff"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export default WelcomeIllustration
